(function (angular, schoolwork12) {

    'use strict';
    angular.module(schoolwork12.app.administrationTools.name)
		.controller(schoolwork12.app.administrationTools.controllers.reactivateAdults, [
			'$rootScope', '$scope', '$http', '$timeout', '$interval', '$uibModal','$location', '$state', '$q',
			schoolwork12.app.auth.services.authentication,
			schoolwork12.app.common.services.eventNotification,
			schoolwork12.app.administrationTools.services.administrationToolsSvc,
			schoolwork12.app.fulfillment.services.getAllSchools,
			function ($rootScope, $scope, $http, $timeout, $interval, $uibModal, $location, $state, $q, authentication, 
					eventNotification, administrationToolsSvc, getSchools) {

				console.info("In Reactivate Adults controller");
				eventNotification.subscribe(schoolwork12.app.auth.events.userLoggedIn,
					function (event, authenticatedUser) {
						console.info('Administration Tools controller: Subscribe On UserLogin Event: '
							.concat(angular.toJson(authenticatedUser)));
							// valid roles for Administration Tools page
							$scope.mainModel.hasTvAdministrationToolsRole = authentication.hasTvAdministrationToolsRole();
					});
				
				$scope.mainModel = {};
				// valid roles for Administration Tools
				if (authentication
						&& authentication.isAuthenticated()) {				
						$scope.mainModel.hasTvAdministrationToolsRole = authentication.hasTvAdministrationToolsRole();
				};	

				//If user refresh the page while is in "Fix Duplicate Adults", this will be redirected back to Admin Tool Main page.
				if(typeof ($scope.$parent.adminTools) == 'undefined' )
					$state.go("adminTools")

				//Initialize global variables and functions
				$scope.showReactivateAdultSucessAlert = false;
				$scope.showReactivateAdultErrorAlert = false;
				$scope.isReactivateAdultsBusy = false;

				//errorMessages
				$scope.reactivateAdultFirstNameRequired = schoolwork12.app.administrationTools.errorMessages.reactivateAdultFirstNameRequired;
            	$scope.reactivateAdultLastNameRequired = schoolwork12.app.administrationTools.errorMessages.reactivateAdultLastNameRequired;
            	$scope.reactivateAdultHomePhoneRequired = schoolwork12.app.administrationTools.errorMessages.reactivateAdultHomePhoneRequired;
				$scope.reactivateAdultHomePhoneInvalid = schoolwork12.app.administrationTools.errorMessages.reactivateAdultHomePhoneInvalid;
				$scope.reactivateAdultDoesntExist = schoolwork12.app.administrationTools.errorMessages.reactivateAdultDoesntExist;
				$scope.reactivateAdultMultiMatch = schoolwork12.app.administrationTools.errorMessages.reactivateAdultMultiMatch;
				$scope.reactivateLCNoActiveStudents = schoolwork12.app.administrationTools.errorMessages.reactivateLCNoActiveStudents;

				$scope.closeReactivateAdultSuccessAlert = function () {
					$scope.showReactivateAdultSucessAlert = false;
				}
				
				let resetFormErrors = function () {
					$scope.forms.reactivateAdults['firstName'].$setValidity('firstNameRequired',true);
					$scope.forms.reactivateAdults['lastName'].$setValidity('lastNameRequired',true);
					$scope.forms.reactivateAdults['homePhone'].$setValidity('homePhoneRequired',true);
					$scope.forms.reactivateAdults['homePhone'].$setValidity('homePhoneInvalid',true);
					$scope.reactivateAdultDoesntExistError = false;
					$scope.showReactivateAdultErrorAlert = false;
					$scope.reactivateAdultMultiMatchError = false;
					$scope.showReactivateAdultSucessAlert = false;
					$scope.reactivateLCNoActiveStudentsError = false;
				}

				let validateReactivateAdultForm = function () {
					resetFormErrors();
					let result = true;
					let homePhoneValue = $scope.reactivateAdultObject.homePhone != null ? $scope.reactivateAdultObject.homePhone.replace(/\D/g, "").trim() : null;

					if($scope.reactivateAdultObject.firstName == null || $scope.reactivateAdultObject.firstName.trim() == ''){
						$scope.forms.reactivateAdults['firstName'].$setValidity('firstNameRequired',false);
						result = false;
					}

					if($scope.reactivateAdultObject.lastName == null || $scope.reactivateAdultObject.lastName.trim() == ''){
						$scope.forms.reactivateAdults['lastName'].$setValidity('lastNameRequired',false);
						result = false;
					}

					if($scope.reactivateAdultObject.homePhone == null || $scope.reactivateAdultObject.homePhone.trim() == ''){
						$scope.forms.reactivateAdults['homePhone'].$setValidity('homePhoneRequired',false);
						result = false;
					}else if(homePhoneValue == ''){ //validate if homePhone is a valid numeric value
						$scope.forms.reactivateAdults['homePhone'].$setValidity('homePhoneInvalid',false);
						result = false;
					}else{
						$scope.reactivateAdultObject.homePhone = homePhoneValue;
					}

					return result;
				}

				$scope.reactivateAdults = function () {
					if(validateReactivateAdultForm()){
						$scope.isReactivateAdultsBusy = true;
						administrationToolsSvc.reactivateAdults(authentication.getCurrentUser().keycode, $scope.reactivateAdultObject)
						.then(function (data) {
							$scope.showReactivateAdultSucessAlert = true;
						},function(error) {
							console.error('Error reactivating Adult...'.concat(angular.toJson(error)));
							$scope.showReactivateAdultErrorAlert = true;
							$scope.reactivateAdultErrorAlertMsg = "";
							if (error.status == 400) {
								$scope.reactivateAdultErrorAlertMsg = $scope.reactivateAdultErrorAlertMsg + error.data;
								$scope.reactivateAdultDoesntExistError = (~$scope.reactivateAdultErrorAlertMsg.indexOf('No adult was found matching the search criteria. Please review and correct the values of the search fields.'));
								$scope.reactivateAdultMultiMatchError = (~$scope.reactivateAdultErrorAlertMsg.indexOf('More than one adult was found matching the search criteria. Please review and correct the values of the search fields.'));
								$scope.reactivateLCNoActiveStudentsError = (~$scope.reactivateAdultErrorAlertMsg.indexOf($scope.reactivateLCNoActiveStudents));
							} else if (error.status == 401 || error.status == 403) {
								$scope.reactivateAdultErrorAlertMsg = schoolwork12.app.errorMessages.sessionExpired;
							} else {
								$scope.reactivateAdultErrorAlertMsg = schoolwork12.app.errorMessages.internalError;
							}
						})['finally'](function () {
							$scope.isReactivateAdultsBusy = false;
						});	
					}else{
						$scope.showReactivateAdultErrorAlert = true;
					}
				}
				
			}
		]);

}(angular, schoolwork12));